let Swiper, Navigation, Pagination, SliderNavigationHelper;

export default class SliderWorkHelper {
    static inject(swiper, navigation, pagination, sliderNavigationHelper) {
        Swiper = swiper;
        Navigation = navigation;
        Pagination = pagination;
        SliderNavigationHelper = sliderNavigationHelper;
    }

    constructor(item) {
        this.xMousePos = 0;
        this.yMousePos = 0;
        this.lastScrolledTop = 0;
        this.lastControl = 'next';

        this.createSwiper(item);
    }

    createSwiper(item) {
        var swiperPagination = item.querySelectorAll('.swiper-pagination')[0];
        var workhelperSliderContainer = item.querySelectorAll(".workhelperSliderContainer")[0];
        var next = item.querySelectorAll(".swiper-button-next")[0];
        var prev = item.querySelectorAll(".swiper-button-prev")[0];

        var snh = new SliderNavigationHelper();
        snh.addFollowMouseListener(next, prev, item);

        var swiper = new Swiper(workhelperSliderContainer, {
            modules: [ Navigation, Pagination ],
            watchOverflow: true,
            pagination: {
                el: swiperPagination,
                clickable: true,
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            slidesPerView: 1,
            spaceBetween: 40,
            breakpoints: {
                //.5 ist wichtig um Sliderbug zu verhindern
                1037.5: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                813.5: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                565.5: {
                    slidesPerView: 2,
                    spaceBetween: 40
                }
            }
        });
        this.swiper = swiper;
    }
}
